var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-scrollable-wrap"},[_c('div',{directives:[{name:"scroll",rawName:"v-scroll:throttle",value:({fn: _vm.$_onScroll, throttle: 32 }),expression:"{fn: $_onScroll, throttle: 32 }",arg:"throttle"}],ref:"scrollContainer",staticClass:"content",class:{disabled:_vm.disabled},attrs:{"options":{
      suppressScrollX:_vm.isDisabledX,
      suppressScrollY:_vm.isDisabledY,
      wheelPropagation:!_vm.isDisabledY,
    }}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }